<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Card Title</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <DividerPrimary :divider="fields.divider" label="Divider" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Card Summary</label>
            <input type="checkbox" v-model="fields.cardSummary.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardSummary.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Slider Items</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row class="mb-2">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.slider.colPerView"
                  type="number"
                  label="Columns per view"
                  min="1"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.slider.spaceBetween"
                  type="number"
                  label="Space between"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion class="mt-2">
              <v-expansion-panel v-for="(item, index) in fields.items" :key="`slider-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Image</label>
                    <UploadImage
                      @callback="obj => handleUploadItemImage(obj, index)"
                      :image="{ imageSrc: item.image || '' }"
                      :height="`140`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveItemImage(index)"
                    />
                  </div>
                  <label class="mb-2 d-block">Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import DividerPrimary from './common/divider-primary.vue';

export default {
  name: 'slider-fastvaluedeal-01-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    DividerPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Slider FastValueDeal 01 Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content: '<h2>Expand Your Entertainment With WaveMax</h2><p>Description</p>',
        },
        divider: {
          show: true,
          maxWidth: 200,
          height: 6,
          backgroundColor: '#E0E0E0',
          align: 'center',
        },
        cardSummary: {
          show: true,
          content: '',
        },
        slider: {
          colPerView: 4,
          spaceBetween: 20,
        },
        items: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        divider: { ...this.fields.divider, ...(extract.divider || {}) },
        cardSummary: { ...this.fields.cardSummary, ...(extract.cardSummary || {}) },
        slider: { ...this.fields.slider, ...(extract.slider || {}) },
        items: Array.isArray(extract.items)
          ? extract.items.map(it => ({ image: it.image || '', content: it.content || '' }))
          : [],
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        items: (this.fields.items || []).map(it => ({ image: it.image || '', content: it.content || '' })),
      };
      const updateHtml = updateHtmlFromData.sectionSliderFastvaluedeal01(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push({
        image: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e173145d8a3b3c0a0e0d.jpg',
        content: '<h3>Unlimited Channel Selection</h3><p>There is endless content out there.</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadItemImage(obj, index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'image', obj.imageSrc || '');
    },
    handleRemoveItemImage(index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'image', '');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
